import * as types from '../../../../types/masters/styles/purity/purityTypes';
import * as api from '../../../../../api/masters/styles/purity/purityApi';

export const fetchPurities = () => async (dispatch) => {
  dispatch({ type: types.FETCH_PURITY_REQUEST });
  try {
    const data = await api.fetchPurities(); // FIX: get the array directly
    dispatch({ type: types.FETCH_PURITY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_PURITY_FAILURE, payload: error.message });
  }
};

export const addPurity = (purity) => async (dispatch) => {
  try {
    const res = await api.addPurity(purity);
    dispatch({ type: types.ADD_PURITY_SUCCESS, payload: res });
    dispatch(fetchPurities());
  } catch (error) {
    dispatch({ type: types.PURITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updatePurity = (id, purity) => async (dispatch) => {
  try {
    const res = await api.updatePurity(id, purity);
    dispatch({ type: types.UPDATE_PURITY_SUCCESS, payload: res });
    dispatch(fetchPurities());
  } catch (error) {
    dispatch({ type: types.PURITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deletePurity = (id) => async (dispatch) => {
  try {
    await api.deletePurity(id);
    dispatch({ type: types.DELETE_PURITY_SUCCESS, payload: id });
    dispatch(fetchPurities());
  } catch (error) {
    dispatch({ type: types.PURITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setPurityEdit = (purity) => ({
  type: types.SET_PURITY_EDIT,
  payload: purity,
});

export const clearPurityEdit = () => ({
  type: types.CLEAR_PURITY_EDIT,
}); 